import script from "./addEventView.vue?vue&type=script&setup=true&lang=ts"
export * from "./addEventView.vue?vue&type=script&setup=true&lang=ts"

import "./addEventView.vue?vue&type=style&index=0&id=3a2b06f2&scoped=true&lang=scss"
import "./addEventView.vue?vue&type=style&index=1&id=3a2b06f2&lang=scss"

import exportComponent from "/home/pilki/freelaix/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a2b06f2"]])

export default __exports__